export default "__VITE_ASSET__Cv8d4YSv__"